// import { getToken, deleteToken  } from "firebase/messaging";
// import firebase from 'firebase/app';
import { messaging } from "../../../firebase-init"; // Ensure you've initialized Firebase and messaging elsewhere
import secure_axios from "../../services/secure_axios";


const initialState = () =>( {
    isNotificationEnabled: false,
    fcmToken: null,
    topics: [],
    vapidKey:"BKF4lA9KeQslzkwuwxFCiToNh5ak7dsk0JVCWzOMLEKD_8AfgWdMcGNVrk20KTdQ8RhyScHS3_tKlw38fS9PsNM",
    isIOS: false,
    notifications: [],
    messages: [],
    drawerOpen: false,
});
const state = initialState();
const mutations= {
    setNotificationEnabled(state, isEnabled) {
      state.isNotificationEnabled = isEnabled;
    },
    setFCMToken(state, token) {
      state.fcmToken = token;
    },
    setTopics(state, topics) {
      state.topics = topics;
    },
    setIsIOS(state, value) {
      state.isIOS = value;
    }
}
const actions = {
    checkPlatform({ commit }) {
      const isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
      commit('setIsIOS', isIOS);
    },
    async requestNotificationPermission({ state, commit, dispatch }) {
        await dispatch('checkPlatform');
        if (state.isIOS) {
          console.log('iOS detected. Push notifications are not fully supported.');
          // Provide alternative messaging or functionality for iOS users
          // For example, you might want to show a message to the user:
          commit('setNotificationEnabled', false);
          // You could dispatch an action to show a message to the user
          dispatch('showIOSNotificationMessage');
          return;
        }
  
        if (!('Notification' in window)) {
          console.log('This browser does not support notifications');
          return;
        }
  
        try {
          // await messaging.requestPermission();
          // const token = await messaging.getToken();
          const permission = await Notification.requestPermission();
          if (permission === 'granted') {
              const token = await messaging.getToken(messaging, { vapidKey: state.vapidKey });
              commit('setFCMToken', token);
              commit('setNotificationEnabled', true);
              await dispatch('updateTokenOnServer', { token, operation: 'add' });
              // dispatch('checkPushNotificationPermission'); 
              dispatch('setupMessageListener');
            } else {
              throw new Error('Permission denied');
            }         
        } catch (err) {
          console.error("Unable to get permission to notify.", err);
          commit('setNotificationEnabled', false);
          // dispatch('checkPushNotificationPermission');
        } finally {
          dispatch('checkPushNotificationPermission');
        }

      },
      async disableNotifications({ state, commit, dispatch }) {
        try {
          // await messaging.deleteToken(state.fcmToken);
          // console.log("Token deleted.");
          if (state.fcmToken) {
            await messaging.deleteToken(messaging, state.fcmToken);
            await dispatch('updateTokenOnServer', { token: state.fcmToken, operation: 'remove' });
          }
          commit('setNotificationEnabled', false);
          commit('setFCMToken', null);
          // await this.updateTokenOnServer({ token: state.fcmToken, operation: 'remove' });
          // dispatch('checkPushNotificationPermission');
        } catch (err) {
          console.error("Unable to delete token. ", err);
        } finally {
          dispatch('checkPushNotificationPermission');
        }

      },
      async refreshToken({ state, commit, dispatch }) {
        // messaging.onTokenRefresh(async () => {
          try {
            // const refreshedToken = await messaging.getToken();
            const refreshedToken = await messaging.getToken(messaging, { vapidKey: state.vapidKey });
            console.log('Token refreshed.');
            commit('setFCMToken', refreshedToken);
            await dispatch('updateTokenOnServer', { token: refreshedToken, operation: 'update' });
          } catch (err) {
            console.error('Unable to retrieve refreshed token ', err);
          }
        // });
      },
      async updateTokenOnServer(_, { token, operation }) {
        console.log(`Updating token on the server: ${token} with operation ${operation}`);
        // Implement the API call to your Flask backend
        try {
          await secure_axios.post('/notification/fcm-token', { FCMTOKEN: token, operation });
          console.log(`Token ${operation}d on server successfully`);
        } catch (error) {
          console.error(`Error ${operation}ing token on server:`, error);
        }
      },
      async addTopic({ dispatch }, topicName) {
        await secure_axios.post('/notification/topics/add', { topicName });
        dispatch('getTopics');
      },
      async toggleSubscription({ dispatch }, { topicName, subscribe }) {
        const action = subscribe ? 'subscribe' : 'unsubscribe';
        await secure_axios.post(`/notification/${action}`, { topicName });
        dispatch('getTopics');
      },
      async getTopics({ commit }) {
        const response = await secure_axios.get('/notification/topics');
        commit('setTopics', response.data.topics);
      },
      async removeTopic({ dispatch }, topicName) {
        await secure_axios.post('/notification/topics/remove', { topicName });
        dispatch('getTopics');
      },
      setupMessageListener({ dispatch }) {
        messaging.onMessage((payload) => {
          console.log('Message received. ', payload);
          dispatch('handleIncomingMessage', payload);
        });
      },
  
      handleIncomingMessage(_, payload) {
        console.log('Handling incoming message', payload);
      },
      checkPushNotificationPermission({ commit }) {
        if ('Notification' in window) {
          commit('setNotificationEnabled', Notification.permission === 'granted');
        } else {
          commit('setNotificationEnabled', false);
        }
      }
    }

export default {
  namespace: true,
  state,
  // getters,
  mutations,
  actions,
};
